/**
 * Simula el canje nativo Android (POST exchange) y devuelve tenant_base_url de la assertion.
 */
function readCookie(name) {
  const parts = String(document.cookie || '').split(';');
  for (const part of parts) {
    const idx = part.indexOf('=');
    if (idx < 0) continue;
    const k = part.slice(0, idx).trim();
    if (k !== name) continue;
    try {
      return decodeURIComponent(part.slice(idx + 1).trim());
    } catch {
      return part.slice(idx + 1).trim();
    }
  }
  return '';
}

function decodeJwtPayload(jwt) {
  const segment = String(jwt || '').split('.')[1];
  if (!segment) throw new Error('Assertion JWT inválida');
  const b64 = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
  return JSON.parse(atob(padded));
}

/**
 * @param {string} redirectTo — URL callback con handshake_id + code
 * @returns {Promise<string>} tenant_base_url
 */
export async function simulateTigerExchangeAndGetTenantUrl(redirectTo) {
  const url = new URL(redirectTo, window.location.origin);
  const handshakeId = url.searchParams.get('handshake_id');
  const code = url.searchParams.get('code');
  if (!handshakeId || !code) {
    throw new Error('Callback sin handshake_id/code');
  }

  const xsrf = readCookie('XSRF-TOKEN');
  if (!xsrf) {
    throw new Error('Sin cookie XSRF-TOKEN (login no seteó sesión Gateway)');
  }

  const requestId = crypto.randomUUID();
  const response = await fetch('/api/mobile-routing/v1/exchange', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-XSRF-TOKEN': xsrf,
    },
    body: JSON.stringify({
      contract_version: 1,
      handshake_id: handshakeId,
      code,
      request_id: requestId,
      app_identity: {
        application_id: 'com.jphlions.wmsnewtest',
        version_name: 'tiger-sim',
        version_code: 0,
        platform: 'ANDROID',
      },
    }),
  });

  let data = null;
  const text = await response.text();
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  if (!response.ok) {
    throw new Error(data?.description || `Exchange HTTP ${response.status}`);
  }

  const assertion = data?.assertion;
  if (!assertion) throw new Error('Exchange sin assertion');
  const claims = decodeJwtPayload(assertion);
  if (claims.event !== 'TENANT_ROUTE' || !claims.tenant_base_url) {
    throw new Error(`Assertion inesperada: event=${claims.event}`);
  }
  return String(claims.tenant_base_url);
}
